import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./config/i18n.js";

import App from "./App.js";
import { Amplify } from "aws-amplify";
import outputs from "./amplify_outputs.json";

import Modal from "react-modal";
Modal.setAppElement("#root"); // Asegúrate de que el id sea el mismo que el de tu aplicación principal

Amplify.configure({
  ...outputs,
  Auth: {
    Cognito: {
      userPoolId: outputs.auth.user_pool_id,
      userPoolWebClientId: outputs.auth.user_pool_client_id,
      identityPoolId: outputs.auth.identity_pool_id,
      allowGuestAccess: true,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
